module.exports = __webpack_public_path__ + "static/media/default-5.63ca7915.svg";